import { render } from "./TicketWaitingV2.vue?vue&type=template&id=5e4c02cc&scoped=true&class=w-100"
import script from "./TicketWaitingV2.vue?vue&type=script&lang=js"
export * from "./TicketWaitingV2.vue?vue&type=script&lang=js"

import "./TicketWaitingV2.vue?vue&type=style&index=0&id=5e4c02cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4c02cc"]])

export default __exports__